import {
    Text,
    Flex,
    TooltipText,
    useTooltip,
    Skeleton,
    Heading,
    Box,
    Button,
    IconButton,
    useModal,
} from "@pancakeswap/uikit";
import * as React from 'react';
import RemoveRoundedIcon from '@mui/icons-material/RemoveRounded';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { UnsupportedChainIdError, useWeb3React } from "@web3-react/core";
import { NoEthereumProviderError } from "@web3-react/injected-connector";
import Balance from "components/Balance";
import { activeNetwork, networks } from "config/networkConfig";
import { ethers, Signer, BigNumber } from "ethers";
import { injected } from "helper/connectors";
import { useEffect, useState } from "react";
import styled, { keyframes, css } from "styled-components";
import TokenABI from "ABI/TokenABI.json";
import DrivenLockupABI from "ABI/DrivenLockupABI.json";
import addresses from "constants/contract";
import { getLockUpAddress, getTokenAddress } from "utils/addressHelpers";
import { getContract, getDrivenContract } from "utils/contractHelpers";
import Pools from "views/Pools";
import VaultStakeModal from "../../CakeVaultCard/VaultStakeModal";
import StakeModal from "../../Modal/StakeModal";
import { Button as Mbutton } from '@mui/material'
import StakeFarmModal from "../../Modal/StakeFarmModal";
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { setPidx, setWidx } from "store/IndexSlice";
import GetSymbolModal from "../../Modal/GetSymbolModal";
import WithdrawModal from "../../Modal/WithdrawModal";
import LoopIcon from '@mui/icons-material/Loop';

interface StakeProps {
    pool: any,
    price: number
}

const Minplsbtn = styled(Button)`
  /* border:2px solid #00FED9  !important; */
  /* color: 00FED9; */
  background-color: #00FED9;
  height:48px;
  line-height:1;
  opacity:1;
  font-weight: 600;
  font-size: 16px !important;
  min-width:48px !important;
  width:100%;
  padding:0px !important;
`
export const ActionContainer = styled.div<{ isAutoVault?: boolean }>`
  padding: 16px;
  border: 2px solid ${({ theme }) => theme.colors.input};
  border-radius: 16px;
  flex-grow: 1;
  flex-basis: 0;
  margin-bottom: 16px;

  ${({ theme }) => theme.mediaQueries.sm} {
    margin-left: 12px;
    margin-right: 12px;
    margin-bottom: 0;
    height: auto;
  }
`;

export const ActionTitles = styled.div`
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  font-size: 12px;
`;

export const ActionContent = styled.div`
  /* padding: 16px; */
  -webkit-box-flex: 1;
  flex-grow: 1;
  flex-basis: 0px;
  margin-bottom: 16px;
`;
export const Fees = styled.div`
  /* padding: 16px; */
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
`;
export const Staking = styled.div`
  /* padding: 16px; */
  font-weight: 600;
  font-size: 12px;
  padding-top: 10px;
`;
const ConnectButton = styled(Button)`
  -webkit-box-align: center;
  align-items: center;
  border: 0px;
  border-radius: 16px;
  box-shadow: rgb(14 14 44 / 40%) 0px -1px 0px 0px inset;
  cursor: pointer;
  display: inline-flex;
  font-family: inherit;
  font-size: 16px;
  font-weight: 600;
  -webkit-box-pack: center;
  justify-content: center;
  letter-spacing: 0.03em;
  line-height: 1;
  opacity: 1;
  outline: 0px;
  transition: background-color 0.2s ease 0s, opacity 0.2s ease 0s;
  height: 48px;
  padding: 0px 24px;
  background-color: #00FED9;
  color: black;
  /* width: 100%; */
  width: 200px;
`;

const StakeEnable = styled(Button)`
    -webkit-box-align: center;
    align-items: center;
    border-radius: 16px;
    cursor: pointer;
    display: inline-flex;
    font-family: inherit;
    font-size: 16px;
    font-weight: 600;
    -moz-box-pack: center;
    justify-content: center;
    letter-spacing: 0.03em;
    line-height: 1;
    opacity: 1;
    outline: currentcolor none 0px;
    transition: background-color 0.2s ease 0s, opacity 0.2s ease 0s;
    height: 48px;
    padding: 0px 24px;
    background-color: transparent;
    border: 2px solid #00FED9;
    box-shadow: none;
    color: white;
    width: 200px;
    /* max-width:250px; */

`

const CompoundButtoon = styled(Button)`
    background-color: red;
    color : #000000;
    border-color: rgb(233, 234, 235);
    box-shadow: none;
    align-items: center;
    border: 0px;
    border-radius: 16px;
    display: inline-flex;
    font-family: inherit;
    font-size: 16px;
    font-weight: 900 !important;
    letter-spacing: 0.03em;
    line-height: 1;
    opacity: 1;
    outline: 0px;
    transition: background-color 0.2s ease 0s, opacity 0.2s ease 0s;
    margin-bottom: 4px;
    height: auto;
    padding: 5px 10px;
    font-size: 12px;
`

const IconButtonWrapper = styled.div`
    display: flex;
    gap: 10px;
`

const StakedBalanace = styled(Box)`
    display: flex;
    justify-content: space-between;
`


const Stake: React.FunctionComponent<StakeProps> = ({ pool, price }) => {
    const pidx = useSelector((state: any) => state.Index.processidx)
    const dispatch = useDispatch()
    // console.log("first", pool)
    const { error, connector, activate, deactivate, library, active, account } = useWeb3React();
    const [stakeEnable, setstackeEnable] = useState("Enable");
    const [loading, setLoading] = useState(false);
    // const [stackbutton, setStackButton] = useState(false);
    const MAX_INT = "115792089237316195423570985008687907853269984665640564039457584007913129639935";
    const allowance = async () => {
        setLoading(true);
        try {
            const contract = getDrivenContract(library.getSigner());
            const allowance1 = await contract.allowance(account, getLockUpAddress());
            // const flag = allowance1.toString() === MAX_INT;
            const flag = allowance1.toString() !== "0";
            // debugger;
            setstackeEnable(flag ? "Stake" : "Enable");
            dispatch(setPidx(pidx + 1))
            setLoading(false);
            return flag;
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
        return false;
    }

    const enable = async () => {
        if (stakeEnable === "Enable") {
            if (await allowance()) {
                return;
            };
        }
        setLoading(true);
        try {
            const contract = getDrivenContract(library.getSigner());
            const tx = await contract.approve(getLockUpAddress(), MAX_INT);
            await tx.wait();
            setstackeEnable("Stake");
        }
        catch (err) {
            console.log(err);
        }
        setLoading(false);

    };
    const connectModal = () => {
        dispatch(setWidx(true))
    }
    useEffect(() => {
        if (active) {
            allowance();
        }
    }, [pool, account]);

    const [stakeDisable, setStakeDisable] = useState(true);
    const [unstakeDisable, setUnStakeDisable] = useState(true);

    useEffect(() => {
        async function checkLockup() {

            if (active && account) {
                const lockUpContract = getContract(DrivenLockupABI, getLockUpAddress());
                let time = await lockUpContract.getLatestLockEndTime(account, pool.stackType);
                if (time.lte(0)) {
                    setStakeDisable(false);
                    setUnStakeDisable(false);
                } else {
                    setStakeDisable(true);
                    setUnStakeDisable(true);
                }
            }
        }
        checkLockup();
    }, [account, pidx])

    useEffect(() => {
        if (error) {
            // networks[activeNetwork]['chainID']
            console.log(error);
            if (error instanceof UnsupportedChainIdError) {
                // changeNetwork();
            } else if (error instanceof NoEthereumProviderError) {
                console.log("No Metamask");
            }
        }
    }, [error]);

    // const [stake, setStake] = React.useState(false);

    const [open, setOpen] = React.useState(false);

    const stake = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [unstakeopen, setUnstakeOpen] = React.useState(false);

    const unstake = () => setUnstakeOpen(true);
    const handleClose1 = () => setUnstakeOpen(false);

    const [symbolopen, setSymbolOpen] = React.useState(false);

    const getSymbol = () => setSymbolOpen(true);
    const symbolClose = () => setSymbolOpen(false);

    const [openfarmmodal, setOpenfarmmodal] = React.useState(false);
    // const [open, setOpenfarmmodal] = React.useState(false);

    const stakefarm = () => setOpenfarmmodal(true);
    const handleClosefarm = () => setOpenfarmmodal(false);

    const [unstakeopenfarmmodal, setUnstakeOpenfarmmodal] = React.useState(false);

    const unstakefarm = () => setUnstakeOpenfarmmodal(true);
    const handleClosefarm1 = () => setUnstakeOpenfarmmodal(false);

    const [withdrawopen, setwithdrawOpen] = React.useState(false);

    const emergencyWithdraw = () => setwithdrawOpen(true);
    const withdrawClose = () => setwithdrawOpen(false);

    const [withdrawloading, setWithdrawLoading] = useState(false); 
    // async function connect(walletType) {
    //     setLoading(true);
    //     try {
    //         await deactivate();
    //         if (walletType === "metamask") {
    //             console.log("Connecting Metamsk");
    //             await activate(injected);
    //         }
    //     } catch (ex) {
    //         console.log(ex);
    //     }
    //     setLoading(false);
    // }

    // const changeNetwork = async () => {
    //     const provider = await connector.getProvider();
    //     const hexString = networks[activeNetwork]["chainId"].toString(16);
    //     await provider.request({
    //         method: "wallet_switchEthereumChain",
    //         params: [{ chainId: "0x" + hexString }],
    //     });
    // };

    const { targetRef, tooltip, tooltipVisible } = useTooltip(
        "Subtracted automatically from each yield harvest and burned.",
        { placement: "bottom-start" }
    );


    //Unstake

    const onUnstake = () => {
        onPresentVaultUnstake()
    }

    const [onPresentVaultUnstake] = useModal(<VaultStakeModal stakingMax={pool} pool={pool} isRemovingStake />)
    const actionTitle = (
        <Text
            fontSize="12px"
            bold
            color="secondary"
            as="span"
            textTransform="uppercase"
        >
            {"Recent CAKE profit"}
        </Text>
    );

    const location = useLocation();


    return (
        <>
            <>
                <Box>
                    <ActionContent>
                        <Fees>
                            {pool.contractType === 'lockup' ? (
                                <>
                                    <Text
                                        fontSize="13px"
                                        lineHeight={1.5}
                                        fontWeight={600}
                                        bold
                                        color="#B1B3CB"
                                        as="span"
                                        textTransform="uppercase"
                                    >
                                        Lock Duration
                                    </Text>
                                    <Flex>
                                        <Balance
                                            lineHeight="1.5"
                                            bold
                                            display="inline"
                                            fontSize="13px"
                                            color="white"
                                            decimals={0}
                                            prefix=""
                                            value={parseInt(pool.duration.toString())}
                                            unit=" Days"
                                        />
                                    </Flex>
                                </>
                            ) : (
                                <></>
                            )}
                        </Fees>
                        <Fees>
                            <Text
                                fontSize="13px"
                                lineHeight={1.5}
                                fontWeight={600}
                                bold
                                color="#B1B3CB"
                                as="span"
                                textTransform="uppercase"
                            >
                                Deposit Fee
                            </Text>
                            <Flex>
                                <Balance
                                    lineHeight="1.5"
                                    bold
                                    display="inline"
                                    fontSize="13px"
                                    color="white"
                                    decimals={2}
                                    prefix=""
                                    value={pool.depositFee}
                                    unit="%"
                                />
                            </Flex>
                        </Fees>
                        <Fees>
                            <Text
                                fontSize="13px"
                                lineHeight={1.5}
                                fontWeight={600}
                                bold
                                color="#B1B3CB"
                                as="span"
                                textTransform="uppercase"
                            >
                                WITHDRAW FEE
                            </Text>
                            <Flex>
                                <Balance
                                    lineHeight="1.5"
                                    bold
                                    display="inline"
                                    fontSize="13px"
                                    color="white"
                                    decimals={2}
                                    prefix=""
                                    value={pool.withdrawFee}
                                    unit="%"
                                />
                            </Flex>
                        </Fees>
                        <Staking>
                            {!active ? (
                                <Text
                                    fontSize="13px"
                                    lineHeight={1.5}
                                    fontWeight={600}
                                    bold
                                    color="white"
                                    as="span"
                                    textTransform="uppercase"
                                >
                                    Start staking
                                </Text>
                            ) : (
                                (parseFloat(ethers.utils.formatEther(pool.user.userstack)) === 0) && <Text
                                    fontSize="13px"
                                    lineHeight={1.5}
                                    fontWeight={600}
                                    bold
                                    color="#00FED9"
                                    as="span"
                                    textTransform="uppercase"
                                >
                                    STAKE DVX
                                </Text>
                            )}
                        </Staking>
                        <Flex>
                            {!active ? (
                                <>
                                    <ConnectButton onClick={() => connectModal()} disabled={loading}>
                                        Connect Wallet
                                    </ConnectButton>{" "}
                                </>
                            ) : (
                                (parseFloat(ethers.utils.formatEther(pool.user.userstack)) == 0) && (<StakeEnable onClick={() => stakeEnable === "Enable" ? enable() : (pool.user.tokenbalance !== "0" ? stake() : getSymbol())} disabled={loading}>{stakeEnable} {loading && <Box><LoopIcon className="animation-spin" sx={{ width: '18px', height: '18px' }} /></Box>}</StakeEnable>)
                            )}
                        </Flex>
                        {active && (parseFloat(ethers.utils.formatEther(pool.user.userstack)) > 0) && <>
                            <Flex flex="1" flexDirection="column" alignSelf="flex-start">
                                <ActionTitles>
                                    <div>
                                        <Text fontSize="12px" bold color="#00FED9" as="span">
                                            DRIVENx {' '}
                                        </Text>
                                        <Text fontSize="12px" bold color="#00FED9" as="span" textTransform="uppercase">
                                            STAKED
                                        </Text>
                                    </div>
                                    <Text>
                                        <CompoundButtoon onClick={() => emergencyWithdraw()} disabled={active && parseFloat(pool.user.pendingreward) > 0.0 ? withdrawloading : true}>
                                           Emergency Withdraw
                                        </CompoundButtoon>
                                    </Text>
                                </ActionTitles>
                                <br />
                                {/* <ActionContent> */}
                                <StakedBalanace>
                                    <Box>
                                        <Balance
                                            lineHeight="1.5"
                                            bold
                                            fontSize="20px"
                                            decimals={2}
                                            value={(parseFloat(ethers.utils.formatEther(pool.user.userstack)))}
                                            color="white"
                                            unit=""
                                            prefix=""
                                        />

                                        <Balance
                                            fontSize="12px"
                                            display="inline"
                                            color="#B1B3CB"
                                            decimals={2}
                                            value={(parseFloat(ethers.utils.formatEther(pool.user.userstack)))*price}
                                            unit=" USD"
                                            prefix="~"
                                        />

                                    </Box>
                                    <IconButtonWrapper>

                                        <Minplsbtn variant="outlined" sx={{ borderRadius: "16px", mr: 1 }} disabled={unstakeDisable} onClick={() => unstake()}>
                                            <RemoveRoundedIcon width="24px" />
                                        </Minplsbtn>

                                        <Minplsbtn variant="outlined" sx={{ borderRadius: "16px", }} disabled={stakeDisable} onClick={() => ((pool.user.tokenbalance !== "0") ? stake() : getSymbol())}>
                                            <AddRoundedIcon width="24px" height="24px" />
                                        </Minplsbtn>

                                    </IconButtonWrapper>
                                    {tooltipVisible && tooltip}
                                </StakedBalanace>

                                {/* </ActionContent> */}

                                {/* <Box mt="16px">
                            <AddCakeButton
                                lockEndTime={lockEndTime}
                                lockStartTime={lockStartTime}
                                currentLockedAmount={cakeAsBigNumber}
                                stakingToken={stakingToken}
                                currentBalance={stakingTokenBalance}
                                stakingTokenBalance={stakingTokenBalance}
                            />
                             </Box> */}
                            </Flex>
                            <Fees>
                                <Text
                                    fontSize="13px"
                                    lineHeight={1.5}
                                    fontWeight={600}
                                    bold
                                    color="#B1B3CB"
                                    as="span"
                                    textTransform="uppercase"
                                >
                                    Locked Until
                                </Text>
                                <Flex>
                                    <Text
                                        fontSize="13px"
                                        lineHeight={1.5}
                                        fontWeight={600}
                                        bold
                                        color="white"
                                        as="span"
                                    // textTransform="uppercase"
                                    >
                                        {pool.user.stakeendin}
                                    </Text>
                                </Flex>
                            </Fees>

                        </>}
                    </ActionContent>
                </Box>
            </>


            {/* </ActionContainer> */}
            <StakeModal open={open} onClose={handleClose} pool={pool} stack={pool.user.tokenbalance}></StakeModal>
            <GetSymbolModal open={symbolopen} onClose={symbolClose}></GetSymbolModal>
            <StakeModal open={unstakeopen} onClose={handleClose1} isRemovingStake pool={pool} stack={pool.user.userstack}></StakeModal>
            <WithdrawModal open={withdrawopen} onClose={withdrawClose} pool={pool}></WithdrawModal>


        </>


    );
};

export default Stake;
